module.exports = __webpack_public_path__ + "img/microsoft.55cff054.png";